import {
  Dialog,
  DialogActions,
  DialogContentText,
  Theme,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { PmiButton } from 'shell/components/shared/button';
import { memo, ReactElement, useCallback } from 'react';
import { useNavigate } from 'react-router';
import { PmiDialogContent } from 'shell/components/shared/dialog/content';
import { PmiDialogTitle } from 'shell/components/shared/dialog/title';
import { useErrorHandler } from 'shell/error/hooks/use-error-handler';
import { HttpStatusCode } from 'shell/types/http-status-code';

//Set the styles
const useStyles = makeStyles((theme: Theme) => ({
  paper: ({ fullScreen }: { fullScreen: boolean }) => ({
    minWidth: fullScreen ? undefined : '30rem',
    color: theme.palette.cdmBrand.main,
  }),
}));

const ErrorHandlerComponent = (): ReactElement => {
  const { error, setError } = useErrorHandler();
  const history = useNavigate();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));
  const classes = useStyles({ fullScreen });

  const onHandleError = useCallback(() => {
    setError();
    if (error?.statusCode === HttpStatusCode.Forbidden) {
      history('/');
    }
  }, [setError, history, error]);

  return (
    <>
      {!!error ? (
        <Dialog
          open={!!error}
          onClose={onHandleError}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          classes={{ paper: classes.paper }}
          fullScreen={fullScreen}
          disableScrollLock
        >
          <PmiDialogTitle id="alert-dialog-title" color="white" backgroundColor="cdmBrand">
            Errore
          </PmiDialogTitle>
          <PmiDialogContent>
            {error?.messages?.map((message) => (
              <DialogContentText key={message} id="alert-dialog-description">
                {message}
              </DialogContentText>
            ))}
          </PmiDialogContent>
          <DialogActions>
            <PmiButton onClick={onHandleError} variant="outlined" color="cdmBrand">
              Ho capito
            </PmiButton>
          </DialogActions>
        </Dialog>
      ) : null}
    </>
  );
};

ErrorHandlerComponent.displayName = 'Error handler - modal component';

export const ErrorHandler = memo(ErrorHandlerComponent);
